import { useEffect, useState } from 'react';

export const useShowFeedback = (
  distribution: number,
  timeout: number,
  timeSinceLastShown: number
) => {
  const [showUXFeedback, setShowUXFeedback] = useState(false);

  useEffect(() => {
    setShowUXFeedback(
      Math.random() < distribution &&
        new Date().valueOf() - timeout > timeSinceLastShown
    );
  }, [distribution, timeout, timeSinceLastShown]);

  return showUXFeedback;
};
